import MapView from '@arcgis/core/views/MapView';
import Search from '@arcgis/core/widgets/Search';
import { MapPlugin, MapPlacement } from '../arcgis-types';

export default function SearchPlugin(
  searchPlacement = MapPlacement.TopLeft,
  styles?: CSSStyleDeclaration,
): MapPlugin {
  return {
    extendMap: (view: MapView) => {
      const container = document.createElement('div');
      if (styles) {
        Object.assign(container.style, styles);
      }

      const searchWidget = new Search({
        container,
        view,
        id: 'search',
      });
      view.ui.add([
        {
          component: searchWidget,
          position: searchPlacement,
          index: 0,
        },
      ]);
    },
    onChange: (mapView) => {
      if (!mapView.ui) return;
      const searchWidget = mapView.ui.find('search');
      if (searchWidget && 'container' in searchWidget && searchWidget.container) {
        // @ts-ignore ts hates that container is either a 'string' or an html object
        Object.assign(searchWidget.container.style, styles);
      }
    },
  };
}
